module.exports = __webpack_public_path__ + "fonts/8a6c3e5a-88a5-430c-91d8-7767ce971d12.f05bc7c.eot";